"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const file_data_service_1 = require("./file-data.service");
const map_event_objects_1 = require("./map-event.objects");
const operators_1 = require("rxjs/operators");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
class StreamDataService {
    constructor(fileManager, fourD) {
        this.fileManager = fileManager;
        this.fourD = fourD;
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this._subs = [];
        this._blacklist = [];
        this._folderEventsSubj = new rxjs_1.Subject();
        this._fileEventsSubj = new rxjs_1.Subject();
        this._sceneEventSubj = new rxjs_1.Subject();
        this._annotsEventSubj = new rxjs_1.Subject();
        this._syncEventSubj = new rxjs_1.Subject();
        this._folderEvents = this._folderEventsSubj.asObservable();
        this._fileEvents = this._fileEventsSubj.asObservable();
        this._sceneEvents = this._sceneEventSubj.asObservable();
        this._annotationEvents = this._annotsEventSubj.asObservable();
        this.__events = ['folder', 'file', 'scene', 'annotation'];
        this.initSockEvents();
        this.initProcessingListeners();
        this.initOtherFileEvents();
        const c = 'background-color:#ddd;color:#521';
        const d = 'font-size:15px;background-color:#cb4;color:#fff';
        /* if(!environment.production){
          this.fourD.onSocketCommand('*!').subscribe(s => console.log('%c v2/stream-data %c socket ',c,d,s))
          this.fileEvents.subscribe(s => console.log('%c v2/stream-data %c fileEvent ',c,d,s.item.name,s.event))
          this.folderEvents.subscribe(s => console.log('%c v2/stream-data %c folderEvent ',c,d,s.item.name,s.event))
        } */
    }
    initSockEvents() {
        this.fourD.onSocketCommand('dropbox_start').subscribe(tc => {
            this.fileManager.processingItems.add({
                task: {
                    id: tc.link,
                    agent: 'dropbox',
                    name: tc.name,
                    targetFolder: tc.targetFolder,
                    size: tc.bytes,
                    isDir: tc.isDir
                }, progress: 0, status: 'Fetching'
            });
        });
        this.fourD.onSocketCommand('dropbox_stop').subscribe(tc => {
            this.fileManager.processingItems.values = this.fileManager.processingItems.values.filter(a => a.task.id != tc.link);
        });
        this.fourD.onSocketCommand('scene_photo_removeall').subscribe(tc => {
            var tg = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.scene.id);
            if (tg) {
                this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(tg, 'photo_removed_all'));
            }
        });
        this.fourD.onSocketCommand('scene_transform_removed').subscribe(tc => {
            var tg = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.scene.id);
            if (tg) {
                this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(tg, 'transform_removed', {
                    id: tc.transform.id,
                    obj: this.fourD.V.findCached(_4d_mapper_1.Transform, tc.transform.id)
                }));
            }
        });
        this.fourD.onSocketCommand('scene_transform_added').subscribe(tc => {
            var tg = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.scene.id);
            var t = this.fourD.V.findCached(_4d_mapper_1.Transform, tc.transform.id);
            if (tg) {
                if (!t) {
                    t = new _4d_mapper_1.Transform(this.fourD.V).set(tc.transform);
                    t.fetchObservable().subscribe(r => {
                        this.fourD.V.registerCacheClass(_4d_mapper_1.Transform, [r]);
                        this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(tg, 'transform_added', {
                            obj: t,
                            id: tc.transform.id
                        }));
                    });
                }
                else {
                    t.set(tc.transform);
                    this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(tg, 'transform_added', t));
                }
            }
        });
        this.fourD.onSocketCommand('scene_photo_added').subscribe(tc => {
            var tg = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.scene.id);
            var t = this.fourD.V.findCached(_4d_mapper_1.Transform, tc.photo.id);
            if (tg) {
                if (tc.photos)
                    tg._photo_count = tc.photos;
                if (!t) {
                    this.fourD.V.searchByObject(_4d_mapper_1.Transform).equals('id', tc.photo.id).useCache(true).limit(780).queryObservable().subscribe(r => {
                        this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(tg, 'photo_added', {
                            obj: r.items[0],
                            id: tc.photo.id
                        }));
                    });
                }
                else {
                    t.set(tc.photo);
                    this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(tg, 'photo_added', t));
                }
            }
        });
        this.fourD.onSocketCommand('create_annotation').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Annotation, tc.id);
            if (!ds) {
                ds = new _4d_mapper_1.Annotation(this.fourD.V).set(tc);
                this.fourD.V.registerCacheClass(_4d_mapper_1.Annotation, [ds]);
                this._annotsEventSubj.next(new map_event_objects_1.AnnotationEvent(ds, 'ADD'));
            }
        });
        this.fourD.onSocketCommand('update_annotation').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Annotation, tc.id);
            if (ds) {
                ds.set(tc);
                this._annotsEventSubj.next(new map_event_objects_1.AnnotationEvent(ds, 'UPDATE'));
            }
        });
        this.fourD.onSocketCommand('delete_annotation').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Annotation, tc.id);
            if (ds)
                this._annotsEventSubj.next(new map_event_objects_1.AnnotationEvent(ds, 'REMOVE'));
        });
        this.fourD.onSocketCommand('create_transform_group').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.id);
            if (!ds) {
                ds = new _4d_mapper_1.TransformGroup(this.fourD.V).set(tc);
                this.fourD.V.registerCacheClass(_4d_mapper_1.TransformGroup, [ds]);
                this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(ds, 'fetched'));
            }
        });
        this.fourD.onSocketCommand('update_transform_group').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.id);
            if (ds) {
                ds.set(tc);
                this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(ds, 'changed'));
            }
        });
        this.fourD.onSocketCommand('delete_transform_group').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.TransformGroup, tc.id);
            if (ds)
                this._sceneEventSubj.next(new map_event_objects_1.SceneEvent(ds, 'unfetched'));
        });
        this.fourD.onSocketCommand('create_folder').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Folder, tc.id);
            if (!ds) {
                ds = new _4d_mapper_1.Folder(this.fourD.V).set(tc);
                this.fourD.V.registerCacheClass(_4d_mapper_1.Folder, [ds]);
                this._folderEventsSubj.next(new file_data_service_1.FolderEvent(ds, 'ADD'));
            }
        });
        this.fourD.onSocketCommand('update_folder').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Folder, tc.id);
            if (ds) {
                ds.set(tc);
                this._folderEventsSubj.next(new file_data_service_1.FolderEvent(ds, 'UPDATE'));
            }
        });
        this.fourD.onSocketCommand('delete_folder').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Folder, tc.id);
            if (ds)
                this._folderEventsSubj.next(new file_data_service_1.FolderEvent(ds, 'REMOVE'));
        });
        this.fourD.onSocketCommand('create_dataset').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Dataset, tc.id);
            if (!ds) {
                ds = new _4d_mapper_1.Dataset(this.fourD.V).set(tc);
                if (this.fourD.activeUser) {
                    ds['__from_user'] = this.fourD.activeUser.id;
                }
                this.fourD.V.registerCacheClass(_4d_mapper_1.Dataset, [ds]);
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(ds, 'ADD', { mode: 'new', socket: 'create_dataset', ref: tc }));
            }
        });
        this.fourD.onSocketCommand('update_dataset').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Dataset, tc.id);
            var dsJob = this.fileManager.processingItems.values.find(a => a.task.id == tc.id);
            if (ds) {
                ds.set(tc);
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(ds, 'UPDATE', { socket: 'update_dataset', mode: 'cached', ref: tc }));
            }
            else {
                var newDS = new _4d_mapper_1.Dataset(this.fourD.V).set(tc);
                this.fourD.V.registerCacheClass(_4d_mapper_1.Dataset, [newDS]);
                newDS.fetchObservable().subscribe(s => this._fileEventsSubj.next(new file_data_service_1.FileEvent(newDS, 'ADD', { socket: 'update_dataset', mode: 'new', ref: tc })));
            }
            if (dsJob) {
                this.fileManager.processingItems.emmit(dsJob, 'UPDATE');
                this.fileManager.processingItems.remove(dsJob);
            }
        });
        this.fourD.onSocketCommand('delete_dataset').subscribe(tc => {
            var ds = this.fourD.V.findCached(_4d_mapper_1.Dataset, tc.id);
            var dsJob = this.fileManager.processingItems.values.find(a => a.task.id == tc.id);
            var dsUl = this.fileManager.uploadingFiles.values.find(a => a.dataset.id == tc.id);
            if (ds) {
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(ds, 'deleted', { mode: 'delete', socket: 'delete_dataset', ref: tc }));
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(ds, 'REMOVE', { socket: 'delete_dataset', ref: tc }));
            }
            if (dsJob) {
                this.fileManager.processingItems.remove(dsJob);
            }
            if (dsUl) {
                this.fileManager.uploadingFiles.remove(dsUl);
            }
        });
    }
    __addIn(these = [], from) {
        these.forEach(me => {
        });
    }
    initProcessingListeners() {
        this.fourD.onSocketCommand('task_update').subscribe(s => {
            // dont keep polling if it made the blacklist
            if (s.dataset && s.dataset.id && this._blacklist.indexOf('t' + s.dataset.id) != -1)
                return;
            if (s.dataset && s.dataset.id) {
                var current = this.fourD.V.findCached(_4d_mapper_1.Dataset, s.dataset && s.dataset.id);
                var load = (j) => {
                    var v = this.fileManager.processingItems.values.find(f => f.task == j);
                    if (!v) {
                        v = {
                            task: j,
                            progress: 1,
                            status: ''
                        };
                    }
                    v.progress = s.progress;
                    v.status = s.status;
                    this.fileManager.processingItems.set(v);
                    if (v.task instanceof _4d_mapper_1.Dataset) {
                        this._fileEventsSubj.next(new file_data_service_1.FileEvent(v.task, 'UPDATE', { mode: 'processing', socket: 'task_update', ref: v }));
                    }
                    if (v.status == 'finished') {
                        this.fileManager.processingItems.emmit(v, 'processing_finished');
                        this.fileManager.processingItems.remove(v);
                    }
                    else if (v.status == 'error') {
                        this.fileManager.processingItems.emmit(v, 'processing_error');
                        this.fileManager.processingItems.remove(v);
                    }
                };
                if (!current) {
                    this.fourD.V.searchByObject(_4d_mapper_1.Dataset).equals('id', s.dataset.id).useCache(true).limit(781).queryObservable().subscribe(res => {
                        if (res.items.length != 1)
                            this._blacklist.push('t' + s.job_id);
                        else
                            load(res.items[0]);
                    });
                }
                else
                    load(current);
            }
        });
        this.fourD.onSocketCommand('job_batch_update').subscribe(s => {
            // dont keep polling if it made the blacklist
            if (s.job_id && this._blacklist.indexOf('j' + s.job_id) != -1)
                return;
            if (s.job_id) {
                var current = this.fourD.V.findCached(_4d_mapper_1.Job, s.job_id);
                var load = (j) => {
                    var v = this.fileManager.processingItems.values.find(f => f.task == j);
                    if (!v) {
                        v = {
                            task: j,
                            progress: 1,
                            status: ''
                        };
                    }
                    v.progress = s.progress;
                    v.status = s.status;
                    this.fileManager.processingItems.set(v);
                    if (v.status == 'finished') {
                        this.fileManager.processingItems.emmit(v, 'processing_finished');
                        this.fileManager.processingItems.remove(v);
                    }
                    else if (v.status == 'error') {
                        this.fileManager.processingItems.emmit(v, 'processing_error');
                        this.fileManager.processingItems.remove(v);
                    }
                };
                if (!current) {
                    this.fourD.V.searchByObject(_4d_mapper_1.Job).equals('id', s.job_id).useCache(true).limit(782).queryObservable().subscribe(res => {
                        if (res.items.length != 1)
                            this._blacklist.push('j' + s.job_id);
                        else
                            load(res.items[0]);
                    });
                }
                else
                    load(current);
            }
        });
    }
    initOtherFileEvents() {
        this._subs.push(this.fileManager.processingItems.events.pipe(operators_1.filter(s => s.item.task instanceof _4d_mapper_1.Dataset)).subscribe(s => {
            if (s.event == 'ADD')
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(s.item.task, 'processing', { ref: s }));
            else if (s.event == 'REMOVE')
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(s.item.task, 'processing_finished', { ref: s }));
            else if (s.event == 'UPDATE')
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(s.item.task, 'UPDATE', { mode: 'process', ref: s }));
        }));
        this._subs.push(this.fileManager.uploadingFiles.events.subscribe(s => {
            if (s.event == 'ADD')
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(s.item.dataset, 'uploading', { ref: s }));
            else if (s.event == 'REMOVE')
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(s.item.dataset, 'upload_finished', { ref: s }));
            else if (s.event == 'UPDATE')
                this._fileEventsSubj.next(new file_data_service_1.FileEvent(s.item.dataset, 'UPDATE', { mode: 'upload', ref: s }));
        }));
    }
    get fileEvents() {
        var presub = [];
        this.fileManager.uploadingFiles.values.forEach(u => presub.push(new file_data_service_1.FileEvent(u.dataset, 'uploading', { ref: u })));
        this.fileManager.processingItems.values.filter(u => u.task instanceof _4d_mapper_1.Dataset).forEach(u => presub.push(new file_data_service_1.FileEvent(u.task, 'uploading', { mode: 'processing?', ref: u })));
        return rxjs_1.concat(presub, this._fileEvents);
    }
    get folderEvents() {
        return this._folderEvents;
    }
    get sceneEvents() {
        return this._sceneEvents;
    }
    get annotationEvents() {
        return this._annotationEvents;
    }
}
exports.StreamDataService = StreamDataService;
